/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_Debt_OverdueInputs */

const vi_notif_type_debt_overdue = /** @type {(inputs: Notif_Type_Debt_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công nợ quá hạn`)
};

/**

* @param {Notif_Type_Debt_OverdueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_debt_overdue = /** @type {((inputs?: Notif_Type_Debt_OverdueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_Debt_OverdueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_debt_overdue(inputs)
});